<script lang="ts">
  // Muted-thread banner (spec §15) with the unmute button.
  import { t } from '$lib/i18n';
  import Icon from '../ui/Icon.svelte';

  let { onunmute }: { onunmute: () => void } = $props();
</script>

<div class="mutedbar">
  <span><Icon name="moon" size={16} /> {t('mutedBanner')}</span>
  <button type="button" class="unsub-btn" onclick={onunmute}>{t('unmuteBtn')}</button>
</div>

<style>
  /* svelte-rwh28b (Reader) — muted bar (shares the .unsub-btn rule with UnsubBar) */
  .mutedbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
    flex-wrap: wrap;
    padding: var(--space-2) var(--space-4);
    background: var(--surface-sunken);
    border-block-end: 1px solid var(--border-subtle);
    font-size: var(--text-sm)
  }

  .mutedbar span {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2)
  }

  .unsub-btn {
    margin-inline-start: auto;
    border: 1px solid var(--border-default);
    border-radius: var(--radius-pill);
    background: var(--surface-card);
    color: var(--text-body);
    padding: var(--space-1) var(--space-4);
    min-block-size: var(--control-md);
    font: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    text-decoration: none
  }
</style>
